<template>
    <div v-if="faqLoaded && faqs.length > 0">
        <div
            v-for="(faq, index) in faqs"
            :key="index"
        >
            <FaqSingle :faq="faq" />
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import FaqSingle from '@/components/FaqSingle';

export default {
    components: { FaqSingle },
    data() {
        return {
            faqLoaded: false,
            faqs: [],
            expanded: false,
        };
    },

    mounted() {
        this.getFaq();
    },

    methods: {
        getFaq() {
            axios.get('/api/faq/show')
                .then(response => {
                    this.faqs = response.data.data.faqs;
                    this.faqLoaded = true;
                })
                .catch(error => {
                    console.error(error);
                });
        }
    }
};
</script>
